import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const LogBarChart = ({
  data = [],
  height = 90,
  colors = d3.schemeTableau10
}) => {
  const svgRef = useRef();
  const wrapperRef = useRef();

  useEffect(() => {
    if (!data || data.length === 0) return;

    const wrapper = wrapperRef.current;
    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove();

    const width = wrapper.getBoundingClientRect().width;
    const margin = { top: 20, right: 20, bottom: 30, left: 40 };
    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;

    const chart = svg
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`);

    const color = d3.scaleOrdinal(colors);

    // Logarithmic scale for y
    const y = d3.scaleLog()
      .domain([1, d3.max(data, d => d.value)]) // avoid log(0)
      .range([chartHeight, 0]);

    const x = d3.scaleBand()
      .domain(data.map(d => d.label))
      .range([0, chartWidth])
      .padding(0.2);

    // Axes
    const xAxis = chart.append("g")
      .attr("transform", `translate(0, ${chartHeight})`)
      .call(d3.axisBottom(x).tickSize(0)); // remove all tick lines
    // chart.append("g")
    //   .call(d3.axisLeft(y).ticks(5, "~s"));

    xAxis.selectAll("text")
      .attr("transform", "rotate(-45)") // rotate vertically
      .style("text-anchor", "end")     // align text nicely
      .style("font-size", "7px")      // smaller font
      .attr("dx", "-0.5em")            // shift horizontally
      .attr("dy", "0.5em");           // shift vertically

    /* ---------- TOOLTIP ---------- */
    const tooltip = d3.select(wrapper)
      .append("div")
      .style("position", "absolute")
      .style("background", "#fff")
      .style("padding", "6px 8px")
      .style("border-radius", "4px")
      .style("box-shadow", "0 4px 10px rgba(0,0,0,0.15)")
      .style("font-size", "11px")
      .style("pointer-events", "none")
      .style("opacity", 0)
      .style("z-index", 9999); 

    /* ---------- BARS ---------- */
    chart.selectAll(".bar")
      .data(data)
      .enter()
      .append("rect")
      .attr("class", "bar")
      .attr("x", d => x(d.label))
      .attr("width", x.bandwidth())
      .attr("y", chartHeight)
      .attr("height", 0)
      .attr("fill", d => color(d.label))
      .on("mouseenter", (event, d) => {
        tooltip
          .style("opacity", 1)
          .html(`<strong>${d.label}</strong>: ${d.value}`);
      })
      .on("mousemove", event => {
        tooltip
          .style("left", event.offsetX + 10 + "px")
          .style("top", event.offsetY - 10 + "px");
      })
      .on("mouseleave", () => {
        tooltip.style("opacity", 0);
      })
      // Animate bars
      .transition()
      .duration(800)
      .attr("y", d => y(d.value))
      .attr("height", d => chartHeight - y(d.value));

    return () => tooltip.remove();
  }, [data, height, colors]);

  return (
    <div
      ref={wrapperRef}
      style={{
        width: "100%",
        position: "relative"
      }}
    >
      <svg ref={svgRef} />
    </div>
  );
};

export default LogBarChart;